import { Pipe, PipeTransform } from '@angular/core';

import { BlockListSpot } from './block-list-spot.models';

@Pipe({
    name: 'addIndexToSpotData',
    standalone: true
})
export class AddIndexToSpotDataPipe implements PipeTransform {
    transform(spot: BlockListSpot, index: number): BlockListSpot {
        return { ...spot, spotIndex: index };
    }
}
